import { getLocalPath, getSharedSiteName } from '../../utility'
import { safeFetch } from '../../../global/data/service.js'

export const getDocumentFromPageModel = (page, pageRef) => {
  if (!page || !pageRef) return {}
  const document = page.model.page[pageRef.split('/page/')[1]]
  return document ? document.data : undefined
}

export const getFileLink = (page, { string, $ref }) => {
  if ($ref) {
    const fileRef = $ref.split('/')[2]
    const urle = page?.model?.page[fileRef]
    return urle?.links?.site?.href || ''
  } else {
    return string
  }
}

export const halApi = async (type, scope, administration = false) => {
  const url = `${getLocalPath()}/halapi/${type}?_limit=40&_scope=/content/documents/${
    administration ? '' : `${getSharedSiteName()}/`
  }${scope}`
  const response = await safeFetch(url)
  if (!response.ok) {
    return
  }
  return await response.json()
}

export const convertToPascalCase = (string) => {
  return string.replace(/\w+/g, function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  })
}
